import React, { useEffect, useState } from 'react';
import { Drawer } from 'antd';
type PropTypes = {
  isOpen: boolean;
  children: React.ReactNode;
  isTitle: string;
  setToggle: () => void;
};
const DrawerModel = ({ isOpen, children, isTitle, setToggle }: PropTypes) => {
  const [open, setOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);

  const showLoading = () => {
    setOpen(true);
  };

  useEffect(() => {
    if (isOpen) {
      showLoading()
    }
    else {
      setOpen(false);
      setLoading(false);

    }

  }, [isOpen])

  return (
    <div >

      <Drawer
        closable
        destroyOnHidden
        title={isTitle}
        placement="right"
        open={open}
        width={"80%"}
        loading={loading}
        onClose={() => { setOpen(false), setToggle() }}
      >
        {children}
      </Drawer>
    </div>
  );
};

export default DrawerModel;